var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCorrect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#00BA00",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.004 13.5078C29.802 13.5078 34.504 18.2099 34.504 24.0079C34.504 29.8059 29.802 34.5079 24.004 34.5079C18.206 34.5079 13.5039 29.8059 13.5039 24.0079C13.5039 18.2099 18.206 13.5078 24.004 13.5078ZM21.8235 27.4184L19.2528 24.8456C18.8149 24.4074 18.8148 23.6928 19.2528 23.2546C19.691 22.8166 20.4087 22.8193 20.8437 23.2546L22.656 25.0684L27.1644 20.56C27.6025 20.1218 28.3172 20.1218 28.7553 20.56C29.1934 20.998 29.1928 21.7133 28.7553 22.1508L23.4501 27.4559C23.0126 27.8934 22.2973 27.8941 21.8593 27.4559C21.847 27.4436 21.8351 27.4311 21.8235 27.4184Z",
    fill: "#00BA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCorrect);
export default __webpack_public_path__ + "static/media/ic_correct.e4957c35ac15341a6ca80cd08d1f1874.svg";
export { ForwardRef as ReactComponent };